@if (loading) {
<div class="page-loading">
  <span>
    <span></span>
  </span>
</div>
} @if (carouselItems) {
<section>
  @if (mainCarousels.items[0]) {
  <section class="flex-row full-row">
    <a
      (click)="
        navigate(
          '/listing/' +
            mainCarousels.items[0].id +
            '/' +
            mainCarousels.items[0].slug
        )
      "
    >
      <img [src]="getImageUrl(mainCarousels.items[0])" />
    </a>
  </section>
  }
  <pc-bambuser-playlist />
  <section>
    <static-carousel />
  </section>
  <section class="flex-row half-row">
    @if (homepageProducts.items[0]) {
    <div>
      <a
        (click)="
          navigate(
            '/listing/' +
              homepageProducts.items[0].id +
              '/' +
              homepageProducts.items[0].slug
          )
        "
      >
        <img [src]="getImageUrl(homepageProducts.items[0])" />
      </a>
    </div>
    } @if (homepageProducts.items[1]) {
    <div>
      <a
        (click)="
          navigate(
            '/listing/' +
              homepageProducts.items[1].id +
              '/' +
              homepageProducts.items[1].slug
          )
        "
      >
        <img [src]="getImageUrl(homepageProducts.items[1])" />
      </a>
    </div>
    }
  </section>
  @if (mainCarousels.items[1]) {
  <section class="flex-row full-row">
    <a
      (click)="
        navigate(
          '/listing/' +
            mainCarousels.items[1].id +
            '/' +
            mainCarousels.items[1].slug
        )
      "
    >
      <img [src]="getImageUrl(mainCarousels.items[1])" />
    </a>
  </section>
  }
  <section class="flex-row half-row">
    @if (homepageProducts.items[2]) {
    <div>
      <a
        (click)="
          navigate(
            '/listing/' +
              homepageProducts.items[2].id +
              '/' +
              homepageProducts.items[2].slug
          )
        "
      >
        <img [src]="getImageUrl(homepageProducts.items[2])" />
      </a>
    </div>
    } @if (homepageProducts.items[3]) {
    <div>
      <a
        (click)="
          navigate(
            '/listing/' +
              homepageProducts.items[3].id +
              '/' +
              homepageProducts.items[3].slug
          )
        "
      >
        <img [src]="getImageUrl(homepageProducts.items[3])" />
      </a>
    </div>
    }
  </section>
</section>
}
